import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sign: "",
    self: null,
  },
  getters: {
  },
  mutations: {
    signSet: (state, str)=> {
      state.sign = str;
    },
    selfSet: (state, obj) => {
      state.self = obj
    }
  },
  actions: {
  },
  modules: {
  }
})
